type DeviceHintNavigator = Pick<Navigator, "userAgent"> & {
  userAgentData?: { mobile?: boolean };
};

/**
 * Identifies phones without using the CSS viewport, which may be widened by
 * browser page zoom. Deliberately do not treat generic touch or Android/iPad
 * devices as phones: tablets and touch-enabled laptops keep desktop access.
 */
export function isPhoneDevice(device: DeviceHintNavigator = window.navigator) {
  if (typeof device.userAgentData?.mobile === "boolean") {
    return device.userAgentData.mobile;
  }

  return /iphone|ipod|windows phone|iemobile|blackberry|bb10|opera mini|android.*mobile/i.test(
    device.userAgent
  );
}

export function dashboardCreateResourcesVisibilityClass(device?: DeviceHintNavigator) {
  return isPhoneDevice(device) ? "hidden" : "hidden md:inline-flex";
}
